import { useRef } from 'react';

import { useAppTakeover } from 'features/app-takeover/hooks/use-app-takeover';
import { useMaybePlayAudioOnceOnMount } from 'features/app-takeover/utils/play-audio-once';

import { CardModal, CustomScrollViewProps } from 'components/card-modal';

import { CartContent } from './components/cart-content';
import { CartContentDebug } from './components/cart-debug';
import { CartDebugFooter } from './components/cart-debug/cart-debug-footer';
import { CartFooter } from './components/cart-footer';
import { CartHeader } from './components/cart-header';
import { useCartContext } from './hooks/use-cart-context';
import { useCartInit } from './hooks/use-cart-init';
import { useCartRedirectToMenu } from './hooks/use-cart-redirect-to-menu';

type CartScreenProps = {
  shouldEvaluateCartRedirect?: boolean;
};

export const CartScreen = ({ shouldEvaluateCartRedirect = true }: CartScreenProps) => {
  const { debug, cartEntries, setCartState } = useCartContext();
  const cartScrollView = useRef<CustomScrollViewProps>(undefined);
  const appTakeover = useAppTakeover();

  useMaybePlayAudioOnceOnMount(appTakeover?.cart?.audio, {
    priority: 1,
    globalPlayOnce: true,
  });

  useCartInit({ cartEntries, setCartState });
  useCartRedirectToMenu({ enabled: shouldEvaluateCartRedirect });

  return (
    <CardModal
      key="cart"
      _headerOverride={<CartHeader />}
      scrollViewRef={cartScrollView}
      scrollView
      webAnimate={false}
      standardPadding
      invertHeaderColor
      isFullScreen
      footer={debug ? <CartDebugFooter /> : <CartFooter />}
    >
      {debug ? <CartContentDebug /> : <CartContent />}
    </CardModal>
  );
};
